import React from 'react';
import { withHydrator } from '@thd-olt-component-react/hydrator';
import { withDynamicComponent, withDynamicImport } from '@thd-nucleus/app-render';
import { withErrorBoundary } from '@thd-olt-component-react/error-boundary';

import { RelatedSearchPlaceholder } from './RelatedSearch/RelatedSearchPlaceholder';
import { dataModelPopularVariations, propTypesPopularVariations } from './PopularVariations/constants';

const placeholder = (
  <RelatedSearchPlaceholder
    color="#E0E0E0"
    showLoadingAnimation
  />
);

const ImportedComponent = withDynamicImport({
  server: () => {
    return __webpack_require__(
      require.resolveWeak('./PopularVariations/PopularVariationsComponent')
    ).PopularVariationsComponent;
  },
  client: () => {
    return import(
      /* webpackPrefetch: true, webpackChunkName: "popular-variations-component" */
      './PopularVariations/PopularVariationsComponent');
  },
  placeholder,
  name: 'PopularVariationsComponent',
});

const HydratedPopularVariations = withHydrator({
  id: 'popular-variations',
  scrollBuffer: 750,
  delay: 2000,
  preserveCtxVal: 'clientStore',
  placeholder
}, ImportedComponent);

const DynamicPopularVariations = withDynamicComponent(HydratedPopularVariations);
export const PopularVariationsImporter = withErrorBoundary(DynamicPopularVariations);

PopularVariationsImporter.displayName = 'PopularVariationsImporter';
PopularVariationsImporter.dataModel = dataModelPopularVariations;
PopularVariationsImporter.propTypes = propTypesPopularVariations;